import React, { FC } from 'react';
import { useSelectedPeriod } from 'src/app/helpers/selected-period';

const ALL = 'all';

/**
 * Üst bardaki kompakt sezon seçici. Seçim global olarak tutulur ve
 * müşteri kayıtları / anasayfa takvimi / ödeme listelerine `period_id` olarak uygulanır.
 */
const SeasonSelector: FC = () => {
  const { periodId, periods, setPeriodId, isLoading } = useSelectedPeriod();

  if (!isLoading && periods.length === 0) return null;

  return (
    <div className="d-flex align-items-center season-selector" title="Görüntülenen sezon">
      <select
        className="form-select form-select-sm form-select-solid fw-bold fs-7 w-150px"
        value={periodId === null ? ALL : String(periodId)}
        disabled={isLoading}
        onChange={(e) => {
          const v = e.target.value;
          setPeriodId(v === ALL ? null : Number(v));
        }}
        aria-label="Sezon seçimi"
      >
        {periods.map((p) => (
          <option key={p.id} value={String(p.id)}>
            {p.name}
            {p.is_active ? ' (Aktif)' : ''}
          </option>
        ))}
        <option value={ALL}>Tüm Veriler</option>
      </select>
    </div>
  );
};

export { SeasonSelector };
